import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import createLogger from 'vuex/dist/logger'
import dashboard from './modules/dashboard'
import classManage from './modules/classManage'
import studentManage from './modules/studentManage'
import base from './modules/base'
import teacherManage from './modules/teacherManage'
import workManage from './modules/workManage'
import myWork from './modules/myWork'
import courseManage from './modules/courseManage'
import intro from './modules/intro'
import dataGraph from './modules/dataGraph'
import unitManage from './modules/unitManage'
import learningStatistics from './modules/learningStatistics'
import markWork from './modules/markWork'
import customization from './modules/customization'
import common from './modules/common'
import mail from './modules/mail'
import mlzTeacher from './modules/mlzTeacher'
import mlzClassEvaList from './modules/mlzClassEvaList'
import mlzStudentEvaList from './modules/mlzStudentEvaList'
import enterSchool from './modules/enterSchool'
import B2C from './modules/B2C'
import schoolApply from './modules/schoolApply'
import contest from './modules/contest'
import teacherRegister from './modules/teacherRegister'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

/**
 * 设置对象的响应式属性.如obj不存在传递进来的属性,则设置属性,否则更新值.支持多层嵌套
 * @param obj {object} 目标对象
 * @param keyString {string} 形如'key.key.key'的字符串
 * @param val {*} 需要设置的值
 */
const setRespondValByKey = function (obj, keyString, val) {
  let current = obj
  const keyArray = keyString.split('.') // 分解key,将字符串转换为数组
  const len = keyArray.length

  if (len > 0) {
    keyArray.forEach((key, index) => {
      if (typeof current[key] === 'undefined') {
        // 如果属性不存在
        if (index < len - 1) {
          // 如果不为最后一个属性,则设置为空对象
          Vue.set(current, key, {})
        } else {
          // 否则,设置值
          Vue.set(current, key, val)
        }
      } else if (index + 1 === len) {
        // 如果原来的对象已经定义,在最后一个属性设置值
        current[key] = val
      }
      current = current[key]
    })
  }
}
// 创建 store 实例
export default new Vuex.Store({
  modules: {
    dashboard,
    classManage,
    studentManage,
    base,
    teacherManage,
    workManage,
    myWork,
    courseManage,
    intro,
    dataGraph,
    unitManage,
    learningStatistics,
    markWork,
    customization,
    common,
    mail,
    mlzTeacher,
    mlzClassEvaList,
    mlzStudentEvaList,
    enterSchool,
    B2C,
    schoolApply,
    teacherRegister,
    contest
  },
  state: {
    user: /-token/.test(document.cookie) ? {} : null,
    customInfo: JSON.parse(localStorage.getItem('customInfo')),
    winShareInfo: null, // 四川文轩智慧校园用户信息
    dledcInfo: null, // 南昌用户信息
    hasToken: false, // 标记这个用户在上一次路由跳转已经获得了登录态，用于在每次路由跳转时节省一次get_access_token的开销
    isOpen: false, // 标记这个用户在上一次路由跳转已经表明这个一个已激活教室的用户， 用于在每次路由跳转时节省一次调用后端接口判断是否激活
    isWeakPassword: false, // 是否弱密码
    isFirst: false,
    isNavPull: false, // 是否隐藏nav
    schoolInfo: null, // 学校信息
    gradeList: [], // 学段列表
    lastMessage: null, // 最新学校审核消息
    skipModalVisible: false // 是否展示完善信息提示模态框
  },
  actions,
  getters,
  mutations: {
    /**
     * 更新对应模块下对应键的值
     * @param state
     * @param module {string} 模块名
     * @param key {string} 对应的键
     * @param value 需要更新的值
     */
    setState (state, { module, key, value }) {
      setRespondValByKey(state[module], key, value)
    },
    ...mutations
  },
  strict: false,
  plugins: debug ? [createLogger()] : []
})
